export default Object.freeze({
  boolean: 'boolean',
  file: 'file',
  image: 'image',
  singleSelect: 'single-select',
  multiSelect: 'multi-select',
  tabSlider: 'tab-slider',
  number: 'number',
  password: 'password',
  text: 'text',
  textarea: 'textarea',
});
